/**
 * API error with HTTP status code preserved.
 * Thrown by hooks when the API returns an error response.
 *
 * The optional `details` field carries structured error context when the
 * server opts in (e.g. reroute `hold_time_hard_block` 409 responses carry a
 * `HoldTimeBlockDetails` payload with the method code, regulatory hold time,
 * remaining minutes, and regulatory program). Consumers MUST narrow the
 * `unknown` type via a type-predicate guard (e.g.
 * `isHoldTimeHardBlockError`) before reading per-shape fields; relying on
 * the raw `details` without narrowing defeats the Rule 5 OpenAPI-source-of-
 * truth invariant.
 *
 * `details` is intentionally excluded from the default `toString()` /
 * stringification path to keep arbitrary server payloads out of error logs.
 */
export class ApiError extends Error {
  readonly status: number;
  readonly code: string | undefined;
  readonly details?: unknown;

  constructor(status: number, message: string, code?: string, details?: unknown) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.code = code;
    this.details = details;
  }
}
